/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  ConcernsIssueTypeDto,
  GetAllConcernsIssueTypesParams,
  IReadOnlyListOfConcernsIssueTypeDto
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns all concernsissuetype enumeration values, with an optional filter.
 */
export const getAllConcernsIssueTypes = (
    params?: GetAllConcernsIssueTypesParams,
 options?: SecondParameter<typeof customInstance<IReadOnlyListOfConcernsIssueTypeDto>>,) => {
      return customInstance<IReadOnlyListOfConcernsIssueTypeDto>(
      {url: `/deployment/concerns-issue-types`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns the ConcernsIssueType identified by the route id.
 */
export const getConcernsIssueTypeById = (
    id: number,
 options?: SecondParameter<typeof customInstance<ConcernsIssueTypeDto>>,) => {
      return customInstance<ConcernsIssueTypeDto>(
      {url: `/deployment/concerns-issue-types/${id}`, method: 'GET'
    },
      options);
    }
  export type GetAllConcernsIssueTypesResult = NonNullable<Awaited<ReturnType<typeof getAllConcernsIssueTypes>>>
export type GetConcernsIssueTypeByIdResult = NonNullable<Awaited<ReturnType<typeof getConcernsIssueTypeById>>>
